module.exports = __webpack_public_path__ + "static/oval-2.5aab04b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/oval/oval-2.png
// module id = 682
// module chunks = 35783957827783